export const fadeIn = ({ duration, delay }) => `
  animation-name: fadeIn;
  animation-duration: ${duration};
  animation-delay: ${delay};
  animation-fill-mode: both;
  @keyframes fadeIn {
    0% {opacity: 0;}
    100% {opacity: 1;}
  }
`;

export const fadeInDown = ({ duration, delay }) => `
  animation-name: fadeInDown;
  animation-duration: ${duration};
  animation-delay: ${delay};
  animation-fill-mode: both;
  @keyframes fadeInDown {
    0% {
      opacity: 0;
      transform: translate3d(0, -10%, 0);
    }
    100% {
      opacity: 1;
      transform: none;
    }
  }
`;

export const fadeInRight = ({ duration, delay }) => `
  animation-name: fadeInRight;
  animation-duration: ${duration};
  animation-delay: ${delay};
  animation-fill-mode: both;
  @keyframes fadeInRight {
    0% {
      opacity: 0;
      transform: translate3d(100%, 0, 0);
    }
    100% {
      opacity: 1;
      transform: none;
    }
  }
`;

export const fadeOutRight = ({ duration, delay }) => `
  animation-name: fadeOutRight;
  animation-duration: ${duration};
  animation-delay: ${delay};
  animation-fill-mode: both;
  @keyframes fadeOutRight {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
      -webkit-transform: translate3d(100%, 0, 0);
      transform: translate3d(100%, 0, 0);
    }
  }  
`;
